import { RefObject, useCallback, useEffect } from "react";
import { useSelector } from "react-redux";

type EventType = 'mousedown' | 'mouseup' | 'click' | 'touchstart';
type OutsideClickHandler = (event: Event) => void;

const useOutsideClick = (
  refs: RefObject<HTMLElement> | RefObject<HTMLElement>[],
  handler: OutsideClickHandler,
  eventType: EventType = 'mousedown',
  reset?: boolean ,
  isPortal:boolean = false
) => {
      const isPortalDateOpen = useSelector((state:any) => state.control.customDatePortalInputOpen)
     console.log(isPortal);
     
      
      const listener = (event: Event) => {
      const target = event.target as Node | null;
      if (!target || !target.isConnected) return;

      const isOutside = Array.isArray(refs)
        ? refs.every(ref => ref.current && !ref.current.contains(target))
        : refs.current && !refs.current.contains(target);

      if (isOutside  ) {
        if(isPortal){
        handler(event);
        }else if(!isPortalDateOpen){
          handler(event);
        }
      }
    };
      const currentCallBack = useCallback(listener,[])
  useEffect(() => {
    if (reset) return;
   if(isPortalDateOpen && !isPortal) return;


    window.addEventListener(eventType, currentCallBack);

    return () => {
      window.removeEventListener(eventType, currentCallBack);
    };
  }, [refs,currentCallBack,  eventType, reset,isPortalDateOpen]);
};

export default useOutsideClick;
